<img src="../../../assets/img/ori31 (26 of 32).jpg" style="object-fit: cover;position: absolute;width: 100%;height: 90vh;">

<div style="overflow-x: hidden;">

    <div class="container page-container">

        <mat-card style="box-shadow: none;background-color: rgba(240, 248, 255, 0);">
            <div class="heading" style="text-align: center;line-height: 0.8;display: flex; justify-content: center;font-size: 4vw; text-shadow: 2px 2px #0d4794; color: rgb(255, 255, 255);;font-weight:500;margin-top: 5%; margin-bottom: 5%;">TUT Online Orientation</div>

            <div class="wrapper fadeInDown">
                <div id="formContent" style="border-radius: 25px; padding-left: 2%;padding-right: 2%;">
                    <h1 class="sec-title" style="margin-top: 5%;margin-bottom: 10%;"> Sign in </h1>
                    <!-- Tabs Titles -->

                    <!-- Icon -->
                    <div class="fadeIn first" style="display: none; padding-bottom: 10px;">

                    </div>

                    <!-- Login Form -->

                    <span *ngIf="error" (click)="removeError()">{{error}}</span>
                    <form #myForm="ngForm">

                        <div class="form-group" style="margin-bottom: 14%;">
                            <label style="text-align: left;width:85%;font-size: medium; font-weight: bold;" for="username">Email</label>
                            <input style="text-align: left;font-size: 1.2rem;"  placeholder="Enter email" type="email" class="form-control" name="email" [(ngModel)]="email"
                                required>

                            <div class="invalid-feedback">
                                <div>Email is required</div>
                            </div>
                        </div>


                        <div class="form-group">
                            <label style="text-align: left;width:85%;font-size: medium; font-weight: bold;" for="password">Password</label>
                            <input style="text-align: left;font-size: 1.2rem;" placeholder="••••••••" type="password" class="form-control" name="password" [(ngModel)]="password" required/>
                            <div class="invalid-feedback">
                                <div>Password is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary" style="width: 70%;border-radius: 15px; margin-top: 20px;" (click)="login()">
                        Login
                    </button>
                        </div>
                    </form>




                    <div id="formFooter" style="border-radius: 25px;margin-top: 05%;background-color: white;">
                        <!-- <a class="underlineHover" (click)="fogotClicked()"><span class="text-danger">I forgot my password</span></a> -->
                        <a class="underlineHover"><span class="text-danger">I forgot my password</span></a>
                        <p> </p>
                        <button class="button" style="width: 70%; margin-top: 10px;border-radius: 15px;" routerLink="/student-reg"> Sign up </button>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>

</div>
